import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      login: undefined,
      isTemporaryUser: false,
    },
  },
  getters: {
    isFormalLogin: (state) => state.user.login && !state.user.isTemporaryUser,
  },
  mutations: {
    setUser(state, value) {
      state.user = value;
      localStorage.setItem("user", JSON.stringify(value));
    },
  },
  actions: {},
  modules: {},
});
